import {InfoIcon} from "@pg-design/icons-module";

import {fieldErrorIcon} from "./FieldErrorIcon.module.css";

const ICON_SIZE = 20;

export const FieldErrorIcon = () => (
    <InfoIcon aria-hidden className={fieldErrorIcon} fill="var(--colors-inputTextError)" width={ICON_SIZE} height={ICON_SIZE} />
);
import {InfoIcon} from "@pg-design/icons-module";

import {fieldErrorIcon} from "./FieldErrorIcon.module.css";

const ICON_SIZE = 20;

export const FieldErrorIcon = () => (
    <InfoIcon aria-hidden className={fieldErrorIcon} fill="var(--colors-inputTextError)" width={ICON_SIZE} height={ICON_SIZE} />
);
